import ClaimYourProfile from '../pages/ClaimYourProfile';

export const allySignupRoute = {
  path: '/onboarding/:networkSlug/ally-signup',
  name: 'Ally signup',
};

export const claimYourProfileRoutes = {
  selectYourCompany: {
    path: '/claim-your-profile/:networkSlug',
    name: 'Select your company',
    component: ClaimYourProfile,
    visibility: ['public', 'onboarding', 'user'],
    exact: true,
  },
  signUp: {
    path: ['/claim-your-profile/:networkSlug/company/:employerSlug'],
    name: 'Sign up',
    component: ClaimYourProfile,
    visibility: ['public', 'onboarding', 'user'],
    exact: true,
  },
  profile: {
    path: ['/claim-your-profile/:networkSlug/company/:employerSlug/profile'],
    name: 'Profile',
    component: ClaimYourProfile,
    visibility: ['public', 'onboarding', 'user'],
    exact: true,
  },
  emailMismatch: {
    path: ['/claim-your-profile/:networkSlug/company/:employerSlug/email_mismatch'],
    name: 'Email mismatch',
    component: ClaimYourProfile,
    visibility: ['public', 'onboarding', 'user'],
    exact: true,
  },
};
